if (!customElements.get('silensa-sample-colours')) {
  customElements.define('silensa-sample-colours', class extends HTMLElement {
    connectedCallback() {
      this.showVariant(this.dataset.selected, false);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) === this.dataset.section && data.variant) {
            this.showVariant(String(data.variant.id), true);
          }
        });
      }
    }
    disconnectedCallback() { this.unsubscribe?.(); }
    showVariant(id, announce) {
      const panels = [...this.querySelectorAll('[data-sample-variant]')];
      const selected = panels.find(panel => panel.dataset.sampleVariant === String(id));
      if (!selected) return;
      panels.forEach(panel => { panel.hidden = panel !== selected; });
      this.dataset.selected = String(id);
      const status = this.querySelector('[data-palette-status]');
      const label = selected.dataset.sampleLabel
        || selected.querySelector('h2, h3, .visually-hidden')?.textContent?.trim();
      const statusPrefix = this.dataset.statusPrefix || 'Kleurenoverzicht:';
      if (announce && status && label) status.textContent = statusPrefix + ' ' + label;
    }
  });
}
